import C from "../../../Constants";
import moment from "moment";

import {
  // 船舶情報マスター
  EnterpriseManningVesselsService,
  // 法人勤務種別サービス
  EnterpriseManningStatusService,
  // 船員マスターサービス
  EnterpriseCrewsService,
  // 法人基本設定マスターサービス
  EnterpriseCrewsBasicConditionsService,
} from "../../../services/master";

const CustomTaskEdit = (() => {
  // 入力フィールド設定
  // 開始日
  const startDateField = {
    type: "datetime",
    label: "開始",
    name: "startDate",
    cls: "b-start-date",
    flex: "1 0 100%",
    weight: 200,
    dateField: {
      editable: false,
    },
    timeField: {
      editable: false,
    },
  };

  // 終了日
  const endDateField = {
    type: "datetime",
    label: "終了",
    name: "endDate",
    cls: "b-end-date",
    flex: "1 0 100%",
    weight: 201,
    dateField: {
      editable: false,
    },
    timeField: {
      editable: false,
    },
  };

  // 下船中様態・休暇希望の備考
  const remarksField = {
    weight: 300,
    label: "備考",
    type: "textfield",
    inputAttributes: {
      tag: "textarea",
    },
    cls: "b-taskeditor-notes-field",
    name: "remarks",
  };

  // 休暇希望の優先度ラジオボタン
  const priorityField = {
    type: "radiogroup",
    name: "priority",
    label: "優先度",
    labelWidth: "6em",
    flex: "0 0 100%",
    weight: 202, // Place before resources field
    options: C.DAY_OFF_REQUEST_PRIORITY_NAME,
  };

  /**
   * 陸上休暇の終了日を開始日 + 基本陸上休暇日数でセットする。
   * @param {number} statusId - 選択された様態ID
   */
  const applyAshoreOffEndDate = statusId => {
    if (!statusId || !_currentTaskRecord || !_currentEditor) return;

    // 選択された様態を取得し、陸上休暇関連か確認する
    const status = EnterpriseManningStatusService.findById(statusId);
    if (
      !status ||
      status.type !== EnterpriseManningStatusService.MANNING_STATUS.OFF
    ) {
      return;
    }

    // タスクに紐づくリソース（船員）を取得する
    const resources = _currentTaskRecord.resources;
    if (!resources || resources.length === 0) return;

    // リソースIDは "c_123" 形式のため、船員IDを取り出す
    const resourceId = resources[0].id;
    const crewId = resourceId.split("_")[1];
    if (!crewId) return;

    // 船員マスターから基本陸上休暇日数を取得する
    const crew = EnterpriseCrewsService.findById(crewId);
    if (!crew || !crew.crew_fiscal_years) return;

    const startDate = _currentTaskRecord.startDate;
    const fiscalYear = EnterpriseCrewsBasicConditionsService.getFiscalYear(
      startDate
    );

    // 指定されている年度の船員の基本陸上休暇日数を取得する
    const fiscalYearData = crew.crew_fiscal_years.find(
      fy => fy.fiscal_year === fiscalYear
    );
    const basicAshoreOffDays = fiscalYearData
      ? fiscalYearData.basic_ashore_off_days
      : null;

    if (!basicAshoreOffDays) return;

    // 終了日 = 開始日 + 基本陸上休暇日数 をデフォルト値としてセットする
    const endDate = moment(startDate)
      .add(basicAshoreOffDays, "days")
      .toDate();
    _currentEditor.widgetMap.endDateField.value = endDate;
  };

  // 下船中様態の種類セレクトボックス
  const offBoadStatusCombo = {
    type: "combo",
    name: "enterprise_manning_status_id",
    label: "下船期間種別",
    weight: 100,

    editable: false,
    disabled: false,
    items: [],

    onChange: ({ value }) => {
      applyAshoreOffEndDate(value);
    },
  };

  // 乗船期間情報のステータスセレクトボックス
  const schedulingStatus = {
    type: "combo",
    name: "scheduling_status",
    editable: false,
    disabled: true,
    label: "ステータス",
    weight: 100,
    items: [
      { value: C.SCHEDULING_STATUS.SCHEDULED, text: "予定" },
      { value: C.SCHEDULING_STATUS.PLANNING, text: "計画中" },
    ],
  };

  /**
   * 船舶のコンボボックスを生成する。
   * @param {*} value
   * @returns
   */
  const _genvesselCombo = value => {
    const items = _vesselRolePostionList.map(v => v.vessel);

    return {
      ref: "vesselCombo",
      type: "combo",
      name: "enterprise_manning_vessel_id",
      label: "船名",
      weight: 101,
      editable: true,
      disabled: false,
      value: value || null,
      items: items,
      onChange: ({ source, value }) => {
        if (!value) return;

        const roleCombo = source.nextSibling;

        const vesselRolePostions = _vesselRolePostionList.find(
          v => v.vessel.value === value
        );

        if (!vesselRolePostions) {
          return;
        }

        roleCombo.items = vesselRolePostions.rolePositions;
        // 選択されている役職ポジションが、選択可能な役職ポジションに含まれない場合は、最初の役職ポジションを選択する。
        if (
          roleCombo.items.findIndex(item => item.value === roleCombo.value) < 0
        ) {
          roleCombo.value = roleCombo.items[0].value;
        }
      },
    };
  };

  // 乗船期間情報の役職セレクトボックス
  const roleCombo = {
    type: "combo",
    name: "enterprise_manning_vessel_role_position_id",
    label: "役職",
    weight: 102,
    editable: true,
    disabled: false,
    items: [],
  };

  const vesselLabel = {
    type: "display",
    label: "船名",
    value: "John Doe",
    weight: 103,
  };

  const roleLabel = {
    type: "display",
    label: "役職",
    value: "John Doe",
    weight: 104,
  };

  // 乗船期間情報の船舶、役職ポジションの組み合わせを保持する変数
  let _vesselRolePostionList = [];

  // 現在編集中のタスクレコードとエディタを保持する変数
  let _currentTaskRecord = null;
  let _currentEditor = null;

  /**
   * 船舶、役職ポジションの組み合わせを更新する。
   * この関数は、船舶のコンボボックスの選択可能な役職ポジションを更新するために使用される。
   * @param {*} selectableList
   */
  const updateVesselRolePositionCombo = (selectableList = []) => {
    _vesselRolePostionList = selectableList;
  };

  const buildCustomTaskEdit = selectableAhoreStausList => {
    offBoadStatusCombo.items = selectableAhoreStausList.map(status => ({
      value: status.id,
      text: status.name,
    }));

    return {
      editorConfig: {
        bbar: {
          items: {
            deleteButton: false,
          },
        },
      },
      // イベント編集中はhasChangesイベントを無効にする
      suspendHasChangesEvent: true,

      // 全てのタブを無効にする。
      items: {
        generalTab: false,
        recurrenceTab: false,
        predecessorsTab: false,
        successorsTab: false,
        advancedTab: false,
        notesTab: false,
        // 休暇希望情報タブ
        dayOffRequestTab: {
          title: "",
          items: {
            startDateField,
            endDateField,
            priorityField,
            remarksField,
          },
        },
        // 下船中様態タブ
        offboardTab: {
          title: "",
          items: {
            offBoadStatusCombo,
            startDateField,
            endDateField,
            remarksField,
          },
        },
        // 乗船期間情報タブ
        onboardTab: {
          title: "",
          items: {
            vesselCombo: _genvesselCombo(),
            roleCombo,
            vesselLabel,
            roleLabel,
            schedulingStatus,
            startDateField,
            endDateField,
          },
        },
      },
    };
  };

  const handleBeforeTaskEditShow = ({ editor, taskRecord }) => {
    _currentTaskRecord = taskRecord;
    _currentEditor = editor;

    let title = "配乗計画";
    if (taskRecord.event_type === C.SCHEDULING_EVENT_TYPE.ASHORE) {
      title = "下船期間情報";
    } else if (
      taskRecord.event_type === C.SCHEDULING_EVENT_TYPE.DAY_OFF_REQUEST
    ) {
      title = "休暇希望";
    }

    editor.title = title;

    const widgetMap = editor.widgetMap;
    // イベントのイベントタイプによってフォームを切り替える
    // リセット => アクティブタブの設定 => タブの表示・非表示の設定の順で行わないと、タブの表示・非表示が正しく反映されない。
    // タブの表示・非表示をリセットする
    widgetMap.offboardTab.hidden = false;
    widgetMap.dayOffRequestTab.hidden = false;
    widgetMap.onboardTab.hidden = false;

    // アクティブタブを設定する
    if (taskRecord.event_type === C.SCHEDULING_EVENT_TYPE.VESSEL) {
      widgetMap.tabs.activeTab = widgetMap.onboardTab;
    }
    if (taskRecord.event_type === C.SCHEDULING_EVENT_TYPE.ASHORE) {
      widgetMap.tabs.activeTab = widgetMap.offboardTab;
    }
    if (taskRecord.event_type === C.SCHEDULING_EVENT_TYPE.DAY_OFF_REQUEST) {
      widgetMap.tabs.activeTab = widgetMap.dayOffRequestTab;
    }

    // タブの表示・非表示を設定する
    // 下船期間情報
    widgetMap.offboardTab.hidden =
      taskRecord.event_type !== C.SCHEDULING_EVENT_TYPE.ASHORE;
    // 休暇希望
    widgetMap.dayOffRequestTab.hidden =
      taskRecord.event_type !== C.SCHEDULING_EVENT_TYPE.DAY_OFF_REQUEST;
    // 乗船期間情報
    widgetMap.onboardTab.hidden =
      taskRecord.event_type !== C.SCHEDULING_EVENT_TYPE.VESSEL;

    // 下船期間情報は新規作成時のみ終了日をデフォルト計算する。
    // 既存イベントは保存済み/手動編集済みの終了日をそのまま使う。
    if (
      taskRecord.event_type === C.SCHEDULING_EVENT_TYPE.ASHORE &&
      taskRecord.isPhantom
    ) {
      applyAshoreOffEndDate(taskRecord.enterprise_manning_status_id);
    }

    if (taskRecord.event_type === C.SCHEDULING_EVENT_TYPE.VESSEL) {
      const isPhantom = taskRecord.isPhantom;

      // 新規作成イベントの場合は、船舶、役職ポジションのコンボボックスを表示する。
      widgetMap.vesselCombo.hidden = !isPhantom;
      widgetMap.roleCombo.hidden = !isPhantom;

      // 既存の乗船期間イベントの場合は、船名、役職ポジションのラベルを表示する。
      widgetMap.vesselLabel.hidden = isPhantom;
      widgetMap.roleLabel.hidden = isPhantom;

      // 既存の計画中イベントはステータス変更できるようにする。
      widgetMap.schedulingStatus.disabled = !(
        !isPhantom &&
        taskRecord.scheduling_status === C.SCHEDULING_STATUS.PLANNING
      );

      // 新規イベントの場合は船舶comboを再作成する(初期値が選択されていないため)
      if (isPhantom) {
        widgetMap.vesselCombo.destroy();
        widgetMap.onboardTab.add(
          _genvesselCombo(taskRecord.enterprise_manning_vessel_id)
        );
      } else {
        // 既存の乗船期間イベントの場合は、船名、役職ポジションのラベルを更新する。
        const vessel = EnterpriseManningVesselsService.findById(
          taskRecord.enterprise_manning_vessel_id
        );

        const rolePosition = EnterpriseManningVesselsService.findRolePositionById(
          taskRecord.enterprise_manning_vessel_role_position_id
        );

        widgetMap.vesselLabel.value = vessel ? vessel.name : "";
        widgetMap.roleLabel.value = rolePosition ? rolePosition.name : "";
      }
    }
  };

  return {
    buildCustomTaskEdit,
    handleBeforeTaskEditShow,
    updateVesselRolePositionCombo,
  };
})();

export default CustomTaskEdit;
